import { render, staticRenderFns } from "./FormLottery.vue?vue&type=template&id=74d00f60&scoped=true&"
import script from "./FormLottery.vue?vue&type=script&lang=js&"
export * from "./FormLottery.vue?vue&type=script&lang=js&"
import style0 from "./FormLottery.vue?vue&type=style&index=0&id=74d00f60&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d00f60",
  null
  
)

export default component.exports